import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PastExpoLayer from "../components/PastExpoLayer";

const PastExpoPage = () => {
    return (
        <MasterLayout>
            <PastExpoLayer />
        </MasterLayout>
    );
};

export default PastExpoPage;
